import request from '@/utils/request'

// 获取订单列表
export function supplyOrderList (data) {
  return request({
    url: '/mcht/supply/supplyOrderList',
    method: 'post',
    data: data
  })
}

export function getSupplierDetail (params) {
  return request({
    url: '/mcht/supply/getSupplierDetail',
    method: 'get',
    params: params
  })
}

export function batchElectron (data) {
  return request({
    url: '/mcht/supply/update/batch/electron',
    method: 'post',
    data: data
  })
}

export function electronLog (data) {
  return request({
    url: '/mcht/supply/electron/log',
    method: 'post',
    data: data
  })
}

export function electronPay (data) {
  return request({
    url: '/mch/account/electron/pay',
    method: 'post',
    data: data
  })
}

export function addAttribute (data) {
  return request({
    url: '/mcht/supply/addAttribute',
    method: 'post',
    data: data
  })
}

export function batchPrint (data) {
  return request({
    url: '/mcht/supply/update/batch/print',
    method: 'post',
    data: data
  })
}

export function settleLogList (params) {
  return request({
    url: '/mcht/supply/settleLogList',
    method: 'get',
    params: params
  })
}

export function supplyMoney (params) {
  return request({
    url: '/mcht/supply/supplyMoney',
    method: 'get',
    params: params
  })
}

export function getSupplierRefundDetail (params) {
  return request({
    url: '/mcht/supply/getSupplierRefundDetail',
    method: 'get',
    params: params
  })
}

export function returnOrderList (params) {
  return request({
    url: '/mcht/supply/returnOrderList',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/supply.js